module.exports = __webpack_public_path__ + "static/media/opel-go-drive.ec583f8d.png";